module.exports = __webpack_public_path__ + "static/icon_jwdj-f26507ea03745663e96f3da34fd2b09f.png";